var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class CustomdisplayFormState {
    constructor() {
        this.open = false;
        this.title = "";
        this.values = new Map();
        this.items = [];
        this.expandedform = new Set();
        makeObservable(this);
    }
    setTitle(title) {
        this.title = title;
    }
    setExpandForm(id) {
        this.expandedform.add(id);
    }
    setHideForm(id) {
        this.expandedform.delete(id);
    }
    reset() {
        this.values.clear();
        this.expandedform.clear();
    }
    setFormItems(items) {
        this.items.splice(0, this.items.length);
        this.items.push(...items);
    }
    setOpen(open) {
        this.open = open;
    }
    setValueForId(id, value) {
        this.values.set(id, {
            id: id,
            value: value
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], CustomdisplayFormState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CustomdisplayFormState.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], CustomdisplayFormState.prototype, "values", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], CustomdisplayFormState.prototype, "items", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], CustomdisplayFormState.prototype, "expandedform", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setExpandForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setHideForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setFormItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], CustomdisplayFormState.prototype, "setValueForId", null);
